<script>
  import Emitter from '@/mixins/emitter';

  export default {
    name: 'YjCheckboxGroup',

    componentName: 'YjCheckboxGroup',

    mixins: [Emitter],

    inject: {
      yjFormItem: {
        default: ''
      }
    },

    props: {
      value: {},
      disabled: Boolean,
      min: Number,
      max: Number,
      size: String,
      fill: String,
      textColor: String
    },

    computed: {
      _yjFormItemSize() {
        return (this.yjFormItem || {}).yjFormItemSize;
      },
      checkboxGroupSize() {
        return this.size || this._yjFormItemSize || (this.$YJ || {}).size;
      }
    },

    watch: {
      value(value) {
        this.dispatch('YjFormItem', 'el.form.change', [value]);
      }
    }
  };
</script>

<template>
  <div class="yj-checkbox-group" role="group" aria-label="checkbox-group">
    <slot></slot>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/checkbox/src/checkbox-group.vue